import type { AssetInfoLifeSpanProps } from "./asset-info-life-span.type";

import { WarningOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";

import { getAssetTheoricalLifespan } from "@/entities/asset";
import { FlexContainerText } from "@/modules/flex-container";
import { capitalize } from "@/utilities/string";

export const AssetInfoLifeSpan = ({ asset }: AssetInfoLifeSpanProps) => {
  const { t } = useTranslation();

  const theoreticalLifespan = getAssetTheoricalLifespan(asset);
  const remainingLifespan = theoreticalLifespan?.remaining;
  const formattedRemainingLifespan = remainingLifespan
    ? capitalize(`${remainingLifespan.text} (${remainingLifespan.date})`)
    : undefined;

  if (!theoreticalLifespan && !remainingLifespan) return null;
  return (
    <>
      {theoreticalLifespan && (
        <FlexContainerText
          value={theoreticalLifespan.text}
          label={t("asset:form.theoreticalLifespan.label")}
        />
      )}
      {remainingLifespan && (
        <FlexContainerText
          value={formattedRemainingLifespan}
          label={t("asset:form.theoreticalRemainingLifespan.label")}
          icon={
            remainingLifespan.value < 0 ? (
              <Tooltip title={t("indicator:assetExceededLifespan")}>
                <WarningOutlined />
              </Tooltip>
            ) : null
          }
        />
      )}
    </>
  );
};
